import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./App.scss";
import "./i18n";

import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

import storageReducer from "./store/reducers/storages";
import ordersReducer from "./store/reducers/orders";
import authReducer from "./store/reducers/auth";
import revenueReducer from "./store/reducers/revenue";
import appReducer from "./store/reducers/appContlols";
import commissionReducer from "./store/reducers/commission";
import couponsReducer from "./store/reducers/coupons";
import linksReducer from "./store/reducers/links";
import organizationReducer from "./store/reducers/organization";
import userReducer from "./store/reducers/user";
import openingHoursReducer from "./store/reducers/openingHours";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  storage: storageReducer,
  orders: ordersReducer,
  revenue: revenueReducer,
  auth: authReducer,
  app: appReducer,
  commission: commissionReducer,
  coupons: couponsReducer,
  links: linksReducer,
  organization: organizationReducer,
  user: userReducer,
  openingHours: openingHoursReducer,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
